import { Helmet } from "react-helmet-async";
import { useLightbox } from "../context/LightboxContext";
import BackButton from "../components/BackButton";
import BackToTop from "../components/BackToTop";

const credits = ["C++", "Assembly", "Visual Basic 6", "Macromedia Flash 8", "Photoshop CS2", "Ubuntu 7", "Corel Draw X3", "Windows XP SP3"];

const stack = ["Ruby on Rails", "React", "React Native", "Expo", "PostgreSQL", "Redis", "Sidekiq", "Linux / GNOME"];

export default function Intro() {
  const showLightbox = useLightbox();

  return (
    <div id="about">
      <Helmet>
        <title>Charlie | Full-Stack Engineer</title>
      </Helmet>

      <section className="page-head">
        <BackButton />
        <h1 className="page-title" style={{ marginTop: 0 }}>SMASH THAT INTRO!</h1>
        <p className="page-sub">The intro, the credits, and the roadmap.</p>
      </section>

      <div className="about-banner">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/b/b0/Jonathan_Davis_%2855209606%29.jpeg"
          alt="Jonathan Davis — Korn"
          onClick={() => showLightbox("https://upload.wikimedia.org/wikipedia/commons/b/b0/Jonathan_Davis_%2855209606%29.jpeg")}
        />
      </div>

      <section className="content-block">
        <p className="lead">
          Hi, I'm Charlie, a full-stack engineer from the Philippines. I find joy in the intersection of desktop
          customization, system tweaking, and exploring the frontiers of web technology. When the digital world pauses,
          I'm often outdoors, riding my Moped and reconnecting with nature.
        </p>
      </section>

      <section className="content-block">
        <h2 className="post-title-huge">Currently<span className="dot">.</span></h2>
        <p className="lead">
          Working on{" "}
          <a href="https://charliegp.vercel.app/blog/tiirada-mobile/">TiiRADA</a> — a community-first, reputation-based
          marketplace for the Davao Region. Diving deeper into DevOps and cloud engineering, one free-tier edge case at a
          time.
        </p>
        <div className="tag-row">
          {stack.map((s) => (
            <span className="tag-pill" key={s}>{s}</span>
          ))}
        </div>
      </section>

      <section className="content-block">
        <h2 className="post-title-huge">Credits<span className="dot">.</span></h2>
        <p className="lead">
          Homage to the legends that shaped my journey: {credits.join(", ")}. These aren't just tools; they defined an
          era.
        </p>
        <p className="lead">
          A professor who possessed an almost superhuman level of patience pushed us to create, to innovate, and to claim
          the title of Software Engineer. That was the first time I felt the weight and gravity of that title, and it
          still gives me goosebumps today.
        </p>
        <p className="lead">
          Thanks to{" "}
          <a href="https://www.linkedin.com/in/ariel-gamao-1b8258152">you</a>, Sir. We did learn the core of CS, and now,
          here we are, toying with the invisible logic of the internet.
        </p>
      </section>

      <section className="content-block">
        <h2 className="post-title-huge">Experience<span className="dot">.</span></h2>
        <p className="lead">
          My career began as a VB.Net developer, modernizing legacy Inventory and Accounts Receivable systems. The core
          challenge was complex data extraction and migration — we successfully transitioned the entire infrastructure
          into Microsoft SQL Server 2005, laying a robust foundation for the future.
        </p>
      </section>

      <section className="content-block">
        <h2 className="post-title-huge">Goals<span className="dot">.</span></h2>
        <p className="lead">
          Working on my startup and enjoying AI agent CLI — which is very Linux at heart — architecting software that
          truly matters to people's lives.
        </p>
        <p className="lead">
          The tools will always change, but a mastery of fundamentals, logic, and experience is what truly matters at the
          end of the day.
        </p>
      </section>

      <section className="content-block">
        <h2 className="post-title-huge">Find me on<span className="dot">.</span></h2>
        <ul id="find-me">
          <li><a href="https://www.linkedin.com/in/charlie-g-pandacan">LinkedIn</a></li>
          <li><a href="https://github.com/gitChang">GitHub</a></li>
          <li><a href="https://stackoverflow.com/users/2612959/charlie">StackOverflow</a></li>
          <li><a href="https://www.deviantart.com/whchaz1027i">DeviantArt</a></li>
          <li><a href="mailto:charliepandacan@gmail.com">GMail</a></li>
        </ul>
      </section>

      <p className="closing-quote">
        Build with purpose<span className="dot">.</span>
      </p>

      <BackToTop />
    </div>
  );
}